export default __webpack_public_path__ + "static/media/magellan.8f4db78f.svg";